import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import AcunetixPremiumCredentialsForm from "./AcunetixPremiumCredentialsForm";
import AcunetixPremiumConfigListing from "./AcunteixPremiumConfigListing";

interface Props {
  // Add props type definition here if needed
}

export default function AcunetixPremiumPullAndPushView(props: Props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={AcunetixPremiumCredentialsForm}
      PullConfigListingView={AcunetixPremiumConfigListing}
      RunOnDemandButtonText={"Sync tool Applications"}
    />
  );
}
